export default __webpack_public_path__ + "static/media/videocam-off.dbb58369.svg";